export class MainNavigation {
  constructor(navigation) {
    this.navigation = navigation;
    this.html = document.querySelector("html");
    this.openedNav = false;
    this.toggleButton = this.navigation.querySelector(
      "[data-toggle]"
    );
    this.submenuButton = this.navigation.querySelectorAll('[aria-haspopup="true"]');
    this.openedSubmenu = false;

    this.toggleButton.addEventListener("click", () => {
      this.toggleNav();
    });

    this.navigation.querySelectorAll("[data-close]").forEach((item) => {
      item.addEventListener("click", () => {
        this.closeNav();
      });
    });

    this.submenuButton.forEach((button) => {
      button.addEventListener("click", () => {
        this.toggleSubmenu(button);
      });
    });

    document.addEventListener("click", (e) => {
      if (!this.navigation.contains(e.target) && this.openedSubmenu !== false) {
        this.closeSubmenu(this.openedSubmenu);
      }
    });
  }

  toggleNav() {
    this.openedNav ? this.closeNav() : this.openNav();
  }

  openNav() {
    this.openedNav = true;
    this.navigation.classList.add("main-navigation--opened");
    document.documentElement.setAttribute("data-main-navigation-opened", "");
  }

  closeNav() {
    this.openedNav = false;
    this.navigation.classList.remove("main-navigation--opened");
    document.documentElement.removeAttribute("data-main-navigation-opened");
  }

  toggleSubmenu(button) {
    this.openedSubmenu === false
      ? this.openSubmenu(button)
      : this.closeSubmenu(button);
  }

  openSubmenu(button) {
    if (this.openedSubmenu) {
      this.closeSubmenu(this.openedSubmenu);
    }
    const target = this.navigation.querySelector(
      "#" + button.getAttribute("aria-controls")
    );
    button.setAttribute("aria-expanded", "true");
    target.setAttribute("aria-hidden", "false");
    this.openedSubmenu = button;
  }

  closeSubmenu(button) {
    const target = this.navigation.querySelector(
      "#" + button.getAttribute("aria-controls")
    );
    button.setAttribute("aria-expanded", "false");
    target.setAttribute("aria-hidden", "true");
    this.openedSubmenu = false;
  }
}
